import React from "react";

interface FilterChipProps {
  children: React.ReactNode;
  onRemove: () => void;
  /** Accessible name of the remove button. */
  removeLabel?: string;
}

/** A committed filter of a searchbar: a pill with its text and a remove "×". */
export const FilterChip: React.FC<FilterChipProps> = ({
  children,
  onRemove,
  removeLabel = "Remove filter",
}) => (
  <span className="inline-flex max-w-full items-center rounded-full bg-semantic-bg-tertiary px-2 py-1 text-xs text-semantic-text-secondary">
    {children}
    <button
      className="ml-2 flex-shrink-0 text-semantic-text-secondary hover:text-semantic-text-danger"
      onClick={onRemove}
      aria-label={removeLabel}
    >
      ×
    </button>
  </span>
);

export default FilterChip;
